import { UnleashClient } from 'unleash-proxy-client';
import {
  Device,
  FlatGroup,
  WorkflowType,
  WorkcellWithWorkflowDeploymentStatus,
} from '@automata/api/apiSchemas';

export type Notify = (message: string, type: 'success' | 'error') => void;

export interface ContextI {
  currentWorkspace: {
    id: string;
    name: string;
    organizationId: string;
    slug: string;
  };
  notify: Notify;
  unleash: UnleashClient;
}

export type ModelType =
  | Device
  | FlatGroup
  | WorkcellWithWorkflowDeploymentStatus;

export enum ModelNames {
  WORKFLOW = 'workflow',
  DEVICE = 'device',
  DEVICESTATE = 'device_state',
  GROUP = 'group',
}

export enum WorkflowTypes {
  PYTHON = 'python',
  GIT = 'git',
  MAESTRO = 'maestro',
  API = 'api',
  SDK = 'sdk',
  CANVAS = 'canvas',
}

export const apiWorkflowTypes: readonly WorkflowType[] = [
  WorkflowTypes.API,
  WorkflowTypes.SDK,
  WorkflowTypes.CANVAS,
] as const;

export const UIModelNames = {
  ...ModelNames,
  USER: 'user',
};
